import { Folder } from '@core/types';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as UserFoldersActions from './user-folders.actions';

export const USER_FOLDERS_FEATURE_KEY = 'user_folders';

export interface UserFoldersState extends EntityState<Folder> {
    lastSavedFolderId?: string;
}

export const userFoldersAdapter = createEntityAdapter<Folder>({
    selectId: (folder: Folder) => folder.id
});

export const userFoldersInitialState: UserFoldersState = userFoldersAdapter.getInitialState();

export const userFoldersReducer = createReducer(
    userFoldersInitialState,
    on(UserFoldersActions.getAllUserFoldersSuccess, (state, { folders }) => userFoldersAdapter.setAll(folders, state)),
    on(UserFoldersActions.createUserFolderSuccess, (state, { folder }) => {
        const newState = userFoldersAdapter.addOne(folder, state);
        return { ...newState, lastSavedFolderId: folder.id };
    }),
    on(UserFoldersActions.updateUserFolderSuccess, (state, { folder }) => {
        const newState = userFoldersAdapter.updateOne(folder, state);
        return { ...newState, lastSavedFolderId: folder.id as string };
    }),
    on(UserFoldersActions.deleteUserFolderSuccess, (state, { id }) => userFoldersAdapter.removeOne(id, state)),
    on(UserFoldersActions.createFolderForSaving, (state, { folder }) => userFoldersAdapter.addOne(folder, state)),
    on(UserFoldersActions.removeFolderForSaving, state => userFoldersAdapter.removeOne('saving_folder', state)),
    on(UserFoldersActions.setLastSavedFolderId, (state, { lastSavedFolderId }) => ({ ...state, lastSavedFolderId }))
);
